import cs_admin from "@app/translations/cs/admin.json";
import cs_components from "@app/translations/cs/components.json";
import cs_default from "@app/translations/cs/default.json";
import cs_lead from "@app/translations/cs/lead.json";
import cs_PDF from "@app/translations/cs/PDF.json";
import cs_productCard from "@app/translations/cs/productCard.json";
import de_admin from "@app/translations/de/admin.json";
import de_components from "@app/translations/de/components.json";
import de_default from "@app/translations/de/default.json";
import de_lead from "@app/translations/de/lead.json";
import de_PDF from "@app/translations/de/PDF.json";
import de_productCard from "@app/translations/de/productCard.json";
import en_admin from "@app/translations/en/admin.json";
import en_components from "@app/translations/en/components.json";
import en_default from "@app/translations/en/default.json";
import en_lead from "@app/translations/en/lead.json";
import en_PDF from "@app/translations/en/PDF.json";
import en_productCard from "@app/translations/en/productCard.json";
import fi_admin from "@app/translations/fi/admin.json";
import fi_components from "@app/translations/fi/components.json";
import fi_default from "@app/translations/fi/default.json";
import fi_lead from "@app/translations/fi/lead.json";
import fi_PDF from "@app/translations/fi/PDF.json";
import fi_productCard from "@app/translations/fi/productCard.json";
import hu_admin from "@app/translations/hu/admin.json";
import hu_components from "@app/translations/hu/components.json";
import hu_default from "@app/translations/hu/default.json";
import hu_lead from "@app/translations/hu/lead.json";
import hu_PDF from "@app/translations/hu/PDF.json";
import hu_productCard from "@app/translations/hu/productCard.json";
import { FALLBACK_LANGUAGE } from "@app/translations/i18n.interfaces";
import ro_admin from "@app/translations/ro/admin.json";
import ro_components from "@app/translations/ro/components.json";
import ro_default from "@app/translations/ro/default.json";
import ro_lead from "@app/translations/ro/lead.json";
import ro_PDF from "@app/translations/ro/PDF.json";
import ro_productCard from "@app/translations/ro/productCard.json";
import sv_admin from "@app/translations/sv/admin.json";
import sv_components from "@app/translations/sv/components.json";
import sv_default from "@app/translations/sv/default.json";
import sv_lead from "@app/translations/sv/lead.json";
import sv_PDF from "@app/translations/sv/PDF.json";
import sv_productCard from "@app/translations/sv/productCard.json";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: FALLBACK_LANGUAGE,
    defaultNS: "default",
    resources: {
      en: {
        default: en_default,
        components: en_components,
        admin: en_admin,
        productCard: en_productCard,
        lead: en_lead,
        PDF: en_PDF,
      },
      fi: {
        default: fi_default,
        components: fi_components,
        admin: fi_admin,
        productCard: fi_productCard,
        lead: fi_lead,
        PDF: fi_PDF,
      },
      de: {
        default: de_default,
        components: de_components,
        admin: de_admin,
        productCard: de_productCard,
        lead: de_lead,
        PDF: de_PDF,
      },
      sv: {
        default: sv_default,
        components: sv_components,
        admin: sv_admin,
        productCard: sv_productCard,
        lead: sv_lead,
        PDF: sv_PDF,
      },
      cs: {
        default: cs_default,
        components: cs_components,
        admin: cs_admin,
        productCard: cs_productCard,
        lead: cs_lead,
        PDF: cs_PDF,
      },
      hu: {
        default: hu_default,
        components: hu_components,
        admin: hu_admin,
        productCard: hu_productCard,
        lead: hu_lead,
        PDF: hu_PDF,
      },
      ro: {
        default: ro_default,
        components: ro_components,
        admin: ro_admin,
        productCard: ro_productCard,
        lead: ro_lead,
        PDF: ro_PDF,
      },
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    detection: {
      lookupCookie: "rauliLng",
      lookupLocalStorage: "rauliLng",
      lookupSessionStorage: "rauliLng",
    },
  });

if (process.env.NODE_ENV === "development") {
  // Add changeLanguage method to window when testing, as calling it's a lot faster to change this way
  // instead of setting localStorage and reloading page
  // @ts-expect-error TS doesn't like setting random functions to window...
  window.changeLanguage = i18n.changeLanguage;
}

export default i18n;
